<template>
  <vxe-grid
    ref="table"
    size="small"
    row-id="pendingGoodsCode"
    border
    resizable
    auto-resize
    highlight-hover-row
    :data="tableData"
    :columns="tableColumns"
    :loading="loading"
    :height="height"
    :toolbar-config="tableToolbar"
    :radio-config="{
      strict: false,
      reserve: true,
      trigger: 'row',
      highlight: true,
    }"
    :seq-config="{ startIndex: (tablePage.curPage - 1) * tablePage.pageSize }"
    @radio-change="radioChange"
  >
    <template #toolbar_form>
      <slot name="header"></slot>
    </template>

    <template #pager>
      <slot name="pager"></slot>
    </template>

    <template #displayImage="{ row }">
      <div class="d-flex">
        <el-image
          :src="row.defaultImageUrl || '/image/static/img/nopic.jpg'"
          :preview-src-list="[
            row.defaultImageUrl || '/image/static/img/nopic.jpg',
          ]"
          fit="cover"
          style="width:100px; height:66px"
          @click.stop
        >
          <div slot="error" class="image-slot">
            <img
              src="/image/static/img/nopic.jpg"
              style="width: 100px; height: 100px"
            />
          </div>
        </el-image>
      </div>
    </template>

    <template #empty>
      <div style="text-align: center">
        <img src="/image/static/img/nodata.png" />
        <p class="no-data mt-2">
          {{ $l('INDEX.table_label_no_data') || '暂无数据！' }}
        </p>
      </div>
    </template>
  </vxe-grid>
</template>
<script>
import tableColumns from './table-columns'
export default {
  props: {
    height: { type: Number, default: 500 },
    loading: { type: Boolean, default: false },
    tableData: { type: Array, default: () => [] },
    tablePage: { type: Object, default: () => {} },
  },
  data() {
    return {
      tableToolbar: { slots: { buttons: 'toolbar_form' } },
      tableColumns: tableColumns(this),
    }
  },
  methods: {
    radioChange({ newValue }) {
      this.$emit('radio-change', newValue)
    },
  },
}
</script>
